import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fnsr-check',
  templateUrl: './check.component.html'
})
export class CheckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
